module.exports = __webpack_public_path__ + "img/bar.653cf5c5.png";